module.exports = __webpack_public_path__ + "img/feature-8.fdda2f58.png";